__turbopack_context__.v({
  "header": "vxhhoq_header",
  "loaderWrapper": "vxhhoq_loaderWrapper",
  "sortingInputWrapper": "vxhhoq_sortingInputWrapper",
  "sortingLabel": "vxhhoq_sortingLabel",
  "title": "vxhhoq_title",
  "wrapper": "vxhhoq_wrapper",
});
